import React, { useState, useEffect} from "react";

import { useGetHabitsQuery } from "@/features/habits/habitsApiSlice";
import { 
  useGetUserHabitLogsQuery, 
  useCreateNewUserHabitLogMutation,
  useUpdateUserHabitLogMutation, // 01 Apr 2026
 } from '@/features/userHabitLogs/userHabitLogsApiSlice' // 29 Jun 2025

import EtEnergyPhysicalIcon1SVGComp from "@/assets/img/icons/svgComp/EtEnergyPhysicalIcon1SVGComp"
import EtEnergyMentalIcon1SVGComp from "@/assets/img/icons/svgComp/EtEnergyMentalIcon1SVGComp"
import EtEnergyEmotionalIcon1SVGComp from "@/assets/img/icons/svgComp/EtEnergyEmotionalIcon1SVGComp"
import EtEnergyIntellectualIcon1SVGComp from "@/assets/img/icons/svgComp/EtEnergyIntellectualIcon1SVGComp"
import EtEnergySpiritualIcon1SVGComp from "@/assets/img/icons/svgComp/EtEnergySpiritualIcon1SVGComp"

import EtHabitsAffirmIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsAffirmIcon1SVGComp"
import EtHabitsDietIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsDietIcon1SVGComp"
import EtHabitsExerciseIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsExerciseIcon1SVGComp"
import EtHabitsGratitudeIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsGratitudeIcon1SVGComp"
import EtHabitsMeditateIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsMeditateIcon1SVGComp"
import EtHabitsReadIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsReadIcon1SVGComp"
import EtHabitsSleepIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsSleepIcon1SVGComp"
import EtHabitsSortIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsSortIcon1SVGComp"
import EtHabitsWriteIcon1SVGComp from "@/assets/img/icons/svgComp/EtHabitsWriteIcon1SVGComp"

import {
  PlusIcon,
  MinusIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline"

import { 
  ClockIcon, 
  CalendarDaysIcon, 
  UserGroupIcon,
  ArrowPathIcon,
  DocumentTextIcon,
  ArrowTrendingUpIcon,
  ShareIcon,
  CheckCircleIcon, 
} from "@heroicons/react/24/solid"

// 02 Jul 2025
import EtHabitPerformanceDetail from "@/components/habits/EtHabitPerformanceDetail"

import { createSvgComponentFromBase64 } from '@/utils/createSvgComponentFromBase64' 

// 06 Dec 2025
import {
  ComposedChart,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Scatter,
  Cell,
  Legend,
  ReferenceLine, // 25 Jul 2026 - Habit average time bars
} from "recharts";


import moment from 'moment' // 29 Jun 2025


const EtTrinityMorningHabits = ({ userId, onClose }) => {

  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - Track and encourage energizing morning habits
  // Updated - 26 Jun 2025 - Added the main logic
  // Updated - 27 Jun 2025 - Habit Performance to create UserHabit Log
  // Updated - 29 Jun 2025 - guidance actions switched from habitInstructions to timeBasedInstructions
  // Updated - 01 Jul 2025 - refined the JSX
  // Updated - 06 Dec 2025 - refined for habit charting and streaks - recharts
  // Updated - 07 Dec 2025 - fixed the indefinite data load issue - useEffect hook - made the dependency array to only activeTimeBucket
  // Updated - 07 Dec 2025 - added habit filter to display only selected habits
  // Updated - 02 Jan 2026 - added time chips for "All" and "By Year"
  // Updated - 02 Jan 2026 - refined the end of quarter moment definition
  // Updated - 02 Jan 2026 - refined to fill in all the days in a time period - completely missed logged days - not present in the incoming habit log data - calendarDays
  // Updated - 03 Jan 2026 - fix for infinite useEffect rerender making the lines to not appear in the charts.
  // Updated - 01 Apr 2026 - fix for habit log updates for the same day
  // Updated - 25 Jul 2026 - added average time, average bar and trend bar to the habits

  // 1a - State Variables
  const [selectedHabitIds, setSelectedHabitIds] = useState([]);
  const [performanceByHabitId, setPerformanceByHabitId] = useState({}); // 27 Jun 2025

  // 29 Jun 2025 - New state additions
  const [performedToggle, setPerformedToggle] = useState({});
  const [timePicker, setTimePicker] = useState({});
  const [experienceNotes, setExperienceNotes] = useState({});
  const [existingLogsMap, setExistingLogsMap] = useState({});
  const [expandedDays, setExpandedDays] = useState({});

  const [activeTimeBucket, setActiveTimeBucket] = useState('today'); //  01 Jul 2025 - 'today' | 'week' | 'month' | 'quarter' | 'year'
 
  // 02 Jan 2026 - Step 4: Active Year (used in By Year mode)
  const [activeYear, setActiveYear] = useState(moment().year());

  // const [percentLoggedNotToday, setPercentLoggedNotToday] = useState(0); // 02 Jul 2025 // 03 Jan 2026 - Commented

  // 06 Dec 2025 - View Tabs: 'log' | 'chart'
  const [activeViewTab, setActiveViewTab] = useState('log');

  const [tooltip, setTooltip] = useState({ visible: false });

  // 2a - Get Backend Data
  const { habits = [] } = useGetHabitsQuery("Habit", {
    selectFromResult: ({ data }) => ({
      habits: data?.ids?.map(id => data?.entities[id])
    }),
  });

  const habitsMorning = habits?.filter(habit => habit?.habitTimeSegments?.includes("Morning"))

  // console.log('habits', habits)
  // console.log('habitsMorning', habitsMorning)

  // 07 Dec 2025
  const [visibleHabits, setVisibleHabits] = useState(() =>
    habitsMorning.map(h => h._id)
  );

  // 25 Jul 2026 - Optional chart analytics overlay controls
  const [showHabitAverageBars, setShowHabitAverageBars] = useState(false);
  const [showHabitTrendLines, setShowHabitTrendLines] = useState(false);

  const hasHabitAnalyticsOverlay =
    showHabitAverageBars || showHabitTrendLines;


  // 2b1 - Fetch existing user habit logs - 29 Jun 2025
  const { data: userHabitLogsData = [] } = useGetUserHabitLogsQuery()
  const [createNewUserHabitLog] = useCreateNewUserHabitLogMutation()
  const [updateUserHabitLog] = useUpdateUserHabitLogMutation() // 01 Apr 2026

  const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
  };

  const userHabitLogs = extractEntitiesFromAdapter(userHabitLogsData)
  // console.log('userHabitLogs', userHabitLogs)

  // --------------------------------------------------------
  // 02 Jan 2026 - Derive available years - for By Year Chip
  // --------------------------------------------------------
  const currentYear = moment().year();

  const availableYears = React.useMemo(() => {
    if (!userHabitLogs || userHabitLogs.length === 0) {
      return [currentYear];
    }

    const yearSet = new Set();

    userHabitLogs.forEach(log => {
      if (!log?.performedAt) return;
      yearSet.add(moment(log.performedAt).year());
    });

    // Always include current year (even if empty so far)
    yearSet.add(currentYear);

    return Array.from(yearSet).sort((a, b) => b - a);
  }, [userHabitLogs, currentYear]);

  // console.log('availableYears', availableYears);

  // --------------------------------------------------
  // 02 Jan 2026 - Default year selection logic
  // --------------------------------------------------
  useEffect(() => {
    if (activeTimeBucket !== 'byYear') return;

    // Only auto-select if activeYear is not valid
    if (!availableYears.includes(activeYear)) {
      setActiveYear(availableYears[0]);
    }

    // Pick most recent available year (usually current year)
    // if (availableYears && availableYears.length > 0) {
    //   setActiveYear(availableYears[0]);
    // }
  }, [activeTimeBucket, availableYears]);


  // 2b2 - Time filters
  const now = moment();
  const startOfToday = moment().startOf("day");
  const endOfToday = moment().endOf("day");

  // 01 Jul 2015
  const startOfWeek = moment().isoWeekday(1).startOf("day"); // Monday of current week
  const endOfWeek = endOfToday; // ✅ Cap at today

  const actualEndOfWeek = moment().isoWeekday(7).endOf("day"); // 02 Jan 2026 Sunday of current week


  const startOfMonth = moment().startOf("month"); // 1st of month
  const endOfMonth = moment().isSame(now, 'month') ? endOfToday : moment().endOf("month");

  const startOfQuarter = moment().startOf("quarter");
  const endOfQuarter = moment().isSame(now, 'quarter') ? endOfToday : moment().endOf("quarter");

  // 02 Jan 2026
  // Semantic (true) quarter end — for display
  const endOfQuarterActual = moment().endOf("quarter");

  // Effective quarter end — for data/chart clipping
  const endOfQuarterEffective = moment().isSame(now, 'quarter')
    ? endOfToday
    : endOfQuarterActual;

  const startOfYear = moment().startOf("year");
  const endOfYear = moment().isSame(now, 'year') ? endOfToday : moment().endOf("year");


  // --------------------------------------------------
  // 02 Jan 2026 - Step A - Expected calendar days for aggregates
  // --------------------------------------------------
  const expectedDates = React.useMemo(() => {
    if (activeTimeBucket === 'today') {
      return [now.format('YYYY-MM-DD')];
    }

    let start;
    let end;

    switch (activeTimeBucket) {
      case 'week':
        start = startOfWeek;
        end = endOfWeek;
        break;

      case 'month':
        start = startOfMonth;
        end = endOfMonth;
        break;

      case 'quarter':
        start = startOfQuarter;
        end = endOfQuarterEffective; // clipped
        break;

      case 'year':
        start = startOfYear;
        end = endOfYear;
        break;

      case 'byYear':
        start = moment().year(activeYear).startOf('year');
        end =
          activeYear === now.year()
            ? endOfToday
            : moment().year(activeYear).endOf('year');
        break;

      case 'all': {
        const minDate = userHabitLogs?.length
          ? moment.min(userHabitLogs.map(l => moment(l.performedAt))).startOf('day')
          : now.startOf('day');
        start = minDate;
        end = endOfToday;
        break;
      }

      default:
        return [];
    }

    const dates = [];
    let cursor = start.clone();

    while (cursor.isSameOrBefore(end, 'day')) {
      dates.push(cursor.format('YYYY-MM-DD'));
      cursor.add(1, 'day');
    }

    return dates;
  }, [
    activeTimeBucket,
    activeYear,
    now,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarterEffective,
    startOfYear,
    endOfYear,
    userHabitLogs,
  ]);

  
  // --------------------------------------------------
  // 02 Jan 2026 - Time bucket descriptive label (formatted)
  // --------------------------------------------------
  const timeBucketDescription = React.useMemo(() => {
    switch (activeTimeBucket) {
      case 'today':
        return (
          <>
            Today is <span className="font-semibold">{now.format('DD MMM YYYY')}</span>
          </>
        );

      case 'week':
        return (
          <>
            This week — Mon (
            <span className="font-semibold">
              {startOfWeek.format('DD MMM YYYY')}
            </span>
            ) - Sun (
            <span className="font-semibold">
              {actualEndOfWeek.format('DD MMM YYYY')}
            </span>
            )
          </>
        );

      case 'month':
        return (
          <>
            This month is{" "}
            <span className="font-semibold">
              {startOfMonth.format('MMMM YYYY')}
            </span>
          </>
        );

      case 'quarter': {
        const quarter = now.quarter();
        return (
          <>
            This quarter is{" "}
            <span className="font-semibold text-orange-600">
              Q{quarter} of {now.year()}
            </span>
            . Starting:{" "}
            <span className="font-semibold">
              {startOfQuarter.format('DD MMM YYYY')}
            </span>
            , Ending:{" "}
            <span className="font-semibold">
              {endOfQuarterActual.format('DD MMM YYYY')}
            </span>
          </>
        );
      }

      case 'year':
        return (
          <>
            This year is{" "}
            <span className="font-semibold">
              {now.year()}
            </span>
          </>
        );

      case 'all':
        return (
          <>
            <span className="font-semibold">All</span> the logged data
          </>
        );

      case 'byYear':
        return (
          <>
            Showing data for year{" "}
            <span className="font-semibold">
              {activeYear}
            </span>
          </>
        );

      default:
        return null;
    }
  }, [
    activeTimeBucket,
    activeYear,
    now,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    startOfQuarter,
    endOfQuarter,
  ]);


  // 2b3 - ✅ Filter logs for today only
  const userHabitLogsToday = userHabitLogs?.filter(log => {
    const logDate = moment(log?.performedAt)
    return logDate.isBetween(startOfToday, endOfToday, null, '[]')
  })

  // 2b4 - ✅ Filter logs for this week - ending today - 01 Jul 2025
  const userHabitLogsThisWeek = userHabitLogs.filter(log => {
  const logDate = moment(log.performedAt)
  return logDate.isBetween(startOfWeek, endOfWeek, null, '[]')
  })

  // 2b5 - ✅ Filter logs for this month - ending today - 01 Jul 2025 
  const userHabitLogsThisMonth = userHabitLogs.filter(log => {
    const logDate = moment(log.performedAt)
    return logDate.isBetween(startOfMonth, endOfMonth, null, '[]')
  })

  // 2b5 - ✅ Filter logs for this quarter - ending today - 01 Jul 2025
  const userHabitLogsThisQuarter = userHabitLogs.filter(log => {
    const logDate = moment(log.performedAt)
    return logDate.isBetween(startOfQuarter, endOfQuarter, null, '[]')
  })

  // 2b5 - ✅ Filter logs for this year - ending today - 01 Jul 2025
  const userHabitLogsThisYear = userHabitLogs.filter(log => {
    const logDate = moment(log.performedAt)
    return logDate.isBetween(startOfYear, endOfYear, null, '[]')
  })

  // console.log('userHabitLogsToday', userHabitLogsToday)
  // console.log('userHabitLogsThisWeek', userHabitLogsThisWeek)
  // console.log('userHabitLogsThisMonth', userHabitLogsThisMonth)
  // console.log('userHabitLogsThisQuarter', userHabitLogsThisQuarter)
  // console.log('userHabitLogsThisYear', userHabitLogsThisYear)
  

  // 2c1 - Determine logs based on active tab - 01 Jul 2025
  let displayedLogs = [];

  switch (activeTimeBucket) {
    case 'week':
      displayedLogs = userHabitLogsThisWeek;
      break;
    case 'month':
      displayedLogs = userHabitLogsThisMonth;
      break;
    case 'quarter':
      displayedLogs = userHabitLogsThisQuarter;
      break;
    case 'year':
      displayedLogs = userHabitLogsThisYear;
      break;
    // 02 Jan 2026
    case 'all':
      displayedLogs = userHabitLogs;
      break;

    // --------------------------------------------------
    // 02 Jan 2026 - By Year filtering
    // --------------------------------------------------
    case 'byYear':
      displayedLogs = userHabitLogs.filter(log => {
        if (!log?.performedAt) return false;

        const logMoment = moment(log.performedAt);
        const logYear = logMoment.year();

        // Must match selected year
        if (logYear !== activeYear) return false;

        // If current year, cap at today
        if (logYear === moment().year()) {
          return logMoment.isSameOrBefore(moment(), 'day');
        }

        return true;
      });
      break;

    case 'today':
    default:
      displayedLogs = userHabitLogsToday;
      break;
  }

  // --------------------------------------------------
  // 02 Jan 2026 - Step B -  Expected day → habit matrix
  // --------------------------------------------------
  const expectedDayHabitMap = React.useMemo(() => {
    const map = {};

    // 1️⃣ Initialize all expected days with all habits = not logged
    expectedDates.forEach(dateKey => {
      map[dateKey] = {};

      habitsMorning.forEach(habit => {
        map[dateKey][habit._id] = {
          performed: false,
          log: null,
        };
      });
    });

    // 2️⃣ Overlay actual logs
    displayedLogs.forEach(log => {
      if (!log?.performedAt || !log?.habitId?._id) return;

      const dateKey = moment(log.performedAt).format('YYYY-MM-DD');
      const habitId = log.habitId._id;

      if (!map[dateKey] || !map[dateKey][habitId]) return;

      map[dateKey][habitId] = {
        performed: !!log.performed,
        log,
      };
    });

    return map;
  }, [expectedDates, habitsMorning, displayedLogs]);


  // 2c2 - Build lookup map for today only (used for performed check + disabling fields)
  const userHabitLogTodayMap = {};
  userHabitLogsToday.forEach(log => {
    const habitId = log?.habitId?._id;
    if (habitId) {
      userHabitLogTodayMap[habitId] = log;
    }
  });

  // 2c3 - Calculate percentage of morning habits logged - 02 Jul 2025
  const totalMorningHabits = habitsMorning?.length || 0;
  const habitsLoggedToday = habitsMorning.filter(habit => !!userHabitLogTodayMap[habit._id]).length;
  const percentLogged = totalMorningHabits > 0 
    ? Math.round((habitsLoggedToday / totalMorningHabits) * 100)
    : 0;

  // 2c4 - Calculate percentage of mornig habits logged not for today - 02 Jul 2025

  //03 Jan 2026 - Fix for infinite rerenders 

    const percentLoggedNotToday = React.useMemo(() => {
    if (activeTimeBucket === 'today') return 0;

    let totalHabitsAcrossDays = 0;
    let totalLoggedAcrossDays = 0;

    Object.values(expectedDayHabitMap).forEach(dayHabits => {
      habitsMorning.forEach(habit => {
        totalHabitsAcrossDays++;

        if (dayHabits?.[habit._id]?.performed) {
          totalLoggedAcrossDays++;
        }
      });
    });

    return totalHabitsAcrossDays > 0
      ? Math.round((totalLoggedAcrossDays / totalHabitsAcrossDays) * 100)
      : 0;
  }, [activeTimeBucket, expectedDayHabitMap, habitsMorning]);


  // Removed
  // useEffect(() => {
  //   if (activeTimeBucket === 'today') return;

  //   let totalHabitsAcrossDays = 0;
  //   let totalLoggedAcrossDays = 0;

  //   Object.values(expectedDayHabitMap).forEach(dayHabits => {
  //     habitsMorning.forEach(habit => {
  //       totalHabitsAcrossDays++;

  //       if (dayHabits?.[habit._id]?.performed) {
  //         totalLoggedAcrossDays++;
  //       }
  //     });
  //   });

  //   const percent =
  //     totalHabitsAcrossDays > 0
  //       ? Math.round((totalLoggedAcrossDays / totalHabitsAcrossDays) * 100)
  //       : 0;

  //   setPercentLoggedNotToday(percent);
  // }, [activeTimeBucket, expectedDayHabitMap, habitsMorning]);


  // -------------------------------------------------------------------
  // 02 Jan 2026 - Derived % for non-today buckets (incl. byYear, all)
  // -------------------------------------------------------------------
  // const percentLoggedNotToday = React.useMemo(() => {
  //   if (activeTimeBucket === 'today') return 0;

  //   const logsByDay = {};

  //   displayedLogs.forEach(log => {
  //     const dayKey = moment(log.performedAt).format('YYYY-MM-DD');
  //     if (!logsByDay[dayKey]) logsByDay[dayKey] = {};
  //     logsByDay[dayKey][log.habitId._id] = log;
  //   });

  //   let totalHabitsAcrossDays = 0;
  //   let totalLoggedAcrossDays = 0;

  //   Object.entries(logsByDay).forEach(([, dayLogs]) => {
  //     habitsMorning.forEach(habit => {
  //       const log = dayLogs?.[habit._id];
  //       totalHabitsAcrossDays++;
  //       if (log?.performed) totalLoggedAcrossDays++;
  //     });
  //   });

  //   return totalHabitsAcrossDays > 0
  //     ? Math.round((totalLoggedAcrossDays / totalHabitsAcrossDays) * 100)
  //     : 0;
  // }, [activeTimeBucket, displayedLogs, habitsMorning]);

  // useEffect(() => {
  //   if (activeTimeBucket === 'today') return;

  //   const logsByDay = {};

  //   displayedLogs.forEach(log => {
  //     const dayKey = moment(log.performedAt).format('YYYY-MM-DD');
  //     if (!logsByDay[dayKey]) logsByDay[dayKey] = {};
  //     logsByDay[dayKey][log.habitId._id] = log;
  //   });

  //   let totalDays = 0;
  //   let totalHabitsAcrossDays = 0;
  //   let totalLoggedAcrossDays = 0;

  //   Object.entries(logsByDay).forEach(([dateKey, dayLogs]) => {
  //     totalDays++;
  //     habitsMorning.forEach(habit => {
  //       const log = dayLogs?.[habit._id];
  //       totalHabitsAcrossDays++;
  //       if (log?.performed) totalLoggedAcrossDays++;
  //     });
  //   });

  //   const percent =
  //     totalHabitsAcrossDays > 0
  //       ? Math.round((totalLoggedAcrossDays / totalHabitsAcrossDays) * 100)
  //       : 0;

  //   setPercentLoggedNotToday(percent);
  // // }, [activeTimeBucket, displayedLogs, habitsMorning]); // 07 Dec 2025 - commented - was causing indefinite load
  // }, [activeTimeBucket]); // 07 Dec 2025


  // 2d - default time
  
  const defaultTime = moment().startOf('minute').format('h:mm A');


  // 2e1 - Plexus Icons Map
  const plexusIconMap = {
    Physical: EtEnergyPhysicalIcon1SVGComp,
    Mental: EtEnergyMentalIcon1SVGComp,
    Emotional: EtEnergyEmotionalIcon1SVGComp,
    Intellectual: EtEnergyIntellectualIcon1SVGComp,
    Spiritual: EtEnergySpiritualIcon1SVGComp,
  };

  // 2e2 - Plexus ColorMap
  const plexusColorMap = {
    Physical: "bg-orange-100 text-orange-800",
    Mental: "bg-yellow-200 text-yellow-800",
    Emotional: "bg-lime-400 text-lime-900",
    Intellectual: "bg-red-300 text-red-900",
    Spiritual: "bg-purple-300 text-purple-900",
  };

  // 3 - Handle Performance Change - 27 Jun 2025
  const handlePerformanceChange = (habitId, value) => {
    setPerformanceByHabitId(prev => ({
      ...prev,
      [habitId]: value
    }));
  };

  // 4 - Submit User Habit Log
  const handleLogIt = async (habit) => {
    const habitId = habit._id;

    // const performed = performedToggle[habitId] || false;
    const performed = true
    const note = experienceNotes[habitId] || '';

    // const selectedTime = timePicker[habitId] || defaultTime;
    // const performedAt = moment(selectedTime, 'h:mm A').toDate();
    // 02 Jul 2025
    const selectedTimeStr = timePicker[habitId];

    const performedAt = selectedTimeStr
    ? moment(selectedTimeStr, 'h:mm A').toDate()
    : moment().toDate(); // fallback to "Now" if nothing selected


    try {
      const payload = {
        habitId,
        habitTimeSegments: ['Morning'], // ✅ even if defaulted, keep it explicit
        performed,
        performedAt,
        durationMin: 0,                 // ⬜ future: allow duration entry
        experienceRating: 0,           // ⬜ future: star/emoji input
        experienceNotes: note ? [{ experienceNoteText: note }] : [],
        pic: '',                        // ⬜ placeholder (future: selfie?)
        aboutMe: '',                    // ⬜ placeholder (future: reflection?)
      };

      const response = await createNewUserHabitLog(payload).unwrap();

      // Add to today’s log map on success
      setExistingLogsMap(prev => ({
        ...prev,
        [habitId]: response,
      }));

    } catch (error) {
      console.error('❌ Error creating habit log:', error);
    }
  };

  // 4b - Update existing User Habit Log - 01 Apr 2026
  const handleUpdateHabitLog = async (habit) => {
    const habitId = habit._id;
    const existingLog = userHabitLogTodayMap?.[habitId];

    if (!existingLog?._id) {
      console.error('❌ No existing habit log found for update');
      return;
    }

    const selectedTimeStr = timePicker[habitId];

    const performedAt = selectedTimeStr
      ? moment(selectedTimeStr, 'HH:mm').toDate()
      : existingLog?.performedAt || moment().toDate();

    const newExperienceNoteText = experienceNotes[habitId] || '';
    const experienceNoteId =
      existingLog?.experienceNotes?.[existingLog.experienceNotes.length - 1]?._id || null;

    try {
      const payload = {
        id: existingLog._id,
        performed: true,
        performedAt,
        durationMin: existingLog?.durationMin || 0,
        experienceRating: existingLog?.experienceRating || 0,
        habitTimeSegments: ['Morning'],
        newExperienceNoteText,
        experienceNoteId,
        pic: existingLog?.pic || '',
        aboutMe: existingLog?.aboutMe || '',
      };

      const response = await updateUserHabitLog(payload).unwrap();

      setExistingLogsMap(prev => ({
        ...prev,
        [habitId]: response,
      }));

    } catch (error) {
      console.error('❌ Error updating habit log:', error);
    }
  };

  // 5 - Transform displayed logs into chart-ready dataset - 06 Dec 2025
  const { chartData, bucketDates } = React.useMemo(() => {
    if (!displayedLogs || displayedLogs.length === 0) {
      return { chartData: [], bucketDates: [] };
    }

    // Determine ordered date list based on active time bucket
    const bucketDates = [];

    let start, end;

    if (activeTimeBucket === 'today') {
      start = moment().startOf('day');
      end = moment().endOf('day');
    } else if (activeTimeBucket === 'week') {
      start = startOfWeek;
      end = endOfWeek;
    } else if (activeTimeBucket === 'month') {
      start = startOfMonth;
      end = endOfMonth;
    } else if (activeTimeBucket === 'quarter') {
      start = startOfQuarter;
      end = endOfQuarter;
    // } else {
    } else if (activeTimeBucket === 'year') {
      start = startOfYear;
      end = endOfYear;
    } else if (activeTimeBucket === 'byYear') {
      // 25 Jul 2026 - Use the complete selected-year range
      start = moment().year(activeYear).startOf('year');

      end =
        activeYear === moment().year()
          ? moment().endOf('day')
          : moment().year(activeYear).endOf('year');
    } else {
      // 02 Jan 2026 - NEW: 'all' (fallback)
      const minDate = displayedLogs?.length
        ? moment.min(displayedLogs.map(l => moment(l.performedAt))).startOf('day')
        : moment().startOf('year');

      start = minDate;
      end = moment().endOf('day'); // cap at today
    }
    // const start = moment(
    //   activeTimeBucket === 'today' ? moment() : (
    //     activeTimeBucket === 'week'   ? startOfWeek :
    //     activeTimeBucket === 'month'  ? startOfMonth :
    //     activeTimeBucket === 'quarter'? startOfQuarter :
    //                                     startOfYear
    //   )
    // );

    // const end = moment(
    //   activeTimeBucket === 'today' ? moment() : (
    //     activeTimeBucket === 'week'   ? endOfWeek :
    //     activeTimeBucket === 'month'  ? endOfMonth :
    //     activeTimeBucket === 'quarter'? endOfQuarter :
    //                                     endOfYear
    //   )
    // );

    // Build list of days for the period
    let dayCursor = start.clone();
    let dayCount = 0;
    // const maxDays = 365; // Safety limit
    const maxDays = 366; // 25 Jul 2026 - Support leap years

    while (dayCursor.isSameOrBefore(end, 'day') && dayCount < maxDays) {
      bucketDates.push(dayCursor.format('YYYY-MM-DD'));
      dayCursor.add(1, 'day');
      dayCount++;
    }

    // Map dates to index
    const dateToIndexMap = {};
    bucketDates.forEach((d, idx) => {
      dateToIndexMap[d] = idx;
    });

    // Transform logs
    const chartData = displayedLogs.map(log => {
      const performedAt = moment(log.performedAt);
      const dateKey = performedAt.format('YYYY-MM-DD');
      const dayIndex = dateToIndexMap[dateKey] ?? 0;

      const epochMinutes =
        performedAt.hours() * 60 + performedAt.minutes();

      const habit = log?.habitId || {};
      const habitId = habit._id;
      const habitName = habit.habitName || "";
      const plexus = habit.habitPlexus || "";

      const color = plexusColorMap[plexus]
        ? plexusColorMap[plexus].split(" ")[0].replace("bg-", "").replace("-100", "")
        : "gray";

      const note = log?.experienceNotes?.at(-1)?.experienceNoteText || "";

      return {
        habitId,
        habitName,
        plexus,
        dateKey,
        dayIndex,
        xValue: dayIndex,                                   // NEW
        xLabel: moment(dateKey).format("DD MMM"),           // NEW
        epochMinutes,
        performedAt: performedAt.toDate(),
        note,
        color,
      }; 
    });

    chartData.sort((a, b) => a.xValue - b.xValue);

    return { chartData, bucketDates };
  }, [
    displayedLogs,
    activeTimeBucket,
    activeYear, // 25 Jul 2026
    // startOfWeek,
    // endOfWeek,
    // startOfMonth,
    // endOfMonth,
    // startOfQuarter,
    // endOfQuarter,
    // startOfYear,
    // endOfYear,
    // plexusColorMap
  ]);

  // 5a — Per-habit series model (Option 1, unified domain with null gaps)
  const { habitSeries, allDatePoints } = React.useMemo(() => {
    if (!chartData || chartData.length === 0) {
      return { habitSeries: [], allDatePoints: [] };
    }

    // 1 — Sort by date
    const sorted = [...chartData].sort((a, b) =>
      moment(a.dateKey).diff(moment(b.dateKey))
    );

    // 2 — Build unique ordered x-axis points (master domain)
    const allDatePoints = [];
    const seen = new Set();
    sorted.forEach((d) => {
      if (!seen.has(d.xValue)) {
        seen.add(d.xValue);
        allDatePoints.push({
          xValue: d.xValue,
          xLabel: d.xLabel,
        });
      }
    });

    // 3 — Stable color palette (no random / no flicker)
    const colorPalette = ["#EA580C", "#2563EB", "#16A34A", "#DB2777", "#7C3AED"];

    // 4 — Initialize per-habit series with full domain, epochMinutes = null
    const habitSeriesMap = {};
    habitsMorning.forEach((habit, index) => {
      habitSeriesMap[habit._id] = {
        habitId: habit._id,
        habitName: habit.habitName,
        color: colorPalette[index % colorPalette.length],
        points: allDatePoints.map((pt) => ({
          xValue: pt.xValue,
          epochMinutes: null,
        })),
      };
    });

    // 5 — Fill actual values for days that have logs
    //     (leaving other days as null so connectNulls can span them)
    sorted.forEach((d) => {
      const series = habitSeriesMap[d.habitId];
      if (!series) return;

      // find the index for this xValue in the full domain
      const idx = allDatePoints.findIndex((pt) => pt.xValue === d.xValue);
      if (idx === -1) return;

      series.points[idx].epochMinutes = d.epochMinutes;
    });

    return {
      habitSeries: Object.values(habitSeriesMap),
      allDatePoints,
    };
  }, [chartData, habitsMorning]);

  // ------------------------------------------------------------
  // 25 Jul 2026 - Year / By Year habit average and trend analytics
  // ------------------------------------------------------------
  const showYearHabitAnalytics =
    activeTimeBucket === 'year' || activeTimeBucket === 'byYear';

  const habitYearAnalytics = React.useMemo(() => {
    const analyticsMap = {};

    habitsMorning.forEach((habit) => {
      const habitPoints = chartData
        .filter(
          point =>
            point.habitId === habit._id &&
            Number.isFinite(point.epochMinutes)
        )
        .sort((a, b) => a.xValue - b.xValue);

      if (habitPoints.length === 0) {
        analyticsMap[habit._id] = {
          averageMinutes: null,
          trendMinutes: null,
          trendDirection: 'none',
          trendPoints: [],
        };

        return;
      }

      // 1 - Average logged time
      const averageMinutes =
        habitPoints.reduce(
          (total, point) => total + point.epochMinutes,
          0
        ) / habitPoints.length;

      // 2 - Linear regression for the habit trend
      const pointCount = habitPoints.length;

      let slope = 0;
      let intercept = averageMinutes;

      if (pointCount > 1) {
        const sumX = habitPoints.reduce(
          (total, point) => total + point.xValue,
          0
        );

        const sumY = habitPoints.reduce(
          (total, point) => total + point.epochMinutes,
          0
        );

        const sumXY = habitPoints.reduce(
          (total, point) =>
            total + point.xValue * point.epochMinutes,
          0
        );

        const sumXSquare = habitPoints.reduce(
          (total, point) =>
            total + point.xValue * point.xValue,
          0
        );

        const denominator =
          pointCount * sumXSquare - sumX * sumX;

        if (denominator !== 0) {
          slope =
            (pointCount * sumXY - sumX * sumY) /
            denominator;

          intercept =
            (sumY - slope * sumX) /
            pointCount;
        }
      }

      const firstXValue = habitPoints[0].xValue;
      const lastXValue =
        habitPoints[habitPoints.length - 1].xValue;

      const firstTrendMinutes =
        slope * firstXValue + intercept;

      const lastTrendMinutes =
        slope * lastXValue + intercept;

      const trendMinutes =
        lastTrendMinutes - firstTrendMinutes;

      analyticsMap[habit._id] = {
        averageMinutes,
        trendMinutes,
        trendDirection:
          Math.abs(trendMinutes) < 1
            ? 'steady'
            : trendMinutes < 0
              ? 'earlier'
              : 'later',

        // Only two points are required for the straight trend bar
        trendPoints:
          pointCount > 1
            ? [
                {
                  xValue: firstXValue,
                  epochMinutes: firstTrendMinutes,
                },
                {
                  xValue: lastXValue,
                  epochMinutes: lastTrendMinutes,
                },
              ]
            : [],
      };
    });

    return analyticsMap;
  }, [chartData, habitsMorning]);

  // 25 Jul 2026 - Consistent display of time values
  const formatHabitMinutes = (minutes) => {
    if (!Number.isFinite(minutes)) return 'No data';

    return moment()
      .startOf('day')
      .add(Math.round(minutes), 'minutes')
      .format('h:mm A');
  };

  // 25 Jul 2026 - Display trend movement as minutes
  const formatHabitTrend = (trendMinutes) => {
    if (!Number.isFinite(trendMinutes)) return 'No trend';

    const roundedMinutes = Math.round(Math.abs(trendMinutes));

    if (roundedMinutes < 1) {
      return 'Trend: steady';
    }

    return `Trend: ${roundedMinutes} min ${
      trendMinutes < 0 ? 'earlier' : 'later'
    } across period`;
  };

  // 25 Jul 2026 - Trend start and end time labels
  const renderTrendEndpoint = ({
    cx,
    cy,
    index,
    payload,
    seriesColor,
    totalPoints,
  }) => {
    if (
      !Number.isFinite(cx) ||
      !Number.isFinite(cy) ||
      !Number.isFinite(payload?.epochMinutes)
    ) {
      return null;
    }

    const isStart = index === 0;
    const isEnd = index === totalPoints - 1;

    if (!isStart && !isEnd) return null;

    return (
      <g>
        {/* Small endpoint marker */}
        <circle
          cx={cx}
          cy={cy}
          r={2.5}
          fill={seriesColor}
        />

        {/* Time value above the trend line */}
        <text
          x={isStart ? cx + 12 : cx - 12}
          y={cy - 10}
          textAnchor={isStart ? 'start' : 'end'}
          fill={seriesColor}
          fontSize={10}
          fontWeight={600}
        >
          {formatHabitMinutes(payload.epochMinutes)}
        </text>
      </g>
    );
  };

  // console.log('allDatePoints', allDatePoints)
  // console.log('habitSeries', habitSeries)

  
  // // 5a — Per-habit series model (Option 1)
  // const { habitSeries, allDatePoints } = React.useMemo(() => {
  //   if (!chartData || chartData.length === 0) {
  //     return { habitSeries: [], allDatePoints: [] };
  //   }

  //   // 1 — Sort by date
  //   const sorted = [...chartData].sort((a, b) =>
  //     moment(a.dateKey).diff(moment(b.dateKey))
  //   );

  //   // 2 — Build unique ordered x-axis points
  //   const allDatePoints = [];
  //   const seen = new Set();
  //   sorted.forEach((d) => {
  //     if (!seen.has(d.xValue)) {
  //       seen.add(d.xValue);
  //       allDatePoints.push({
  //         xValue: d.xValue,
  //         xLabel: d.xLabel,
  //       });
  //     }
  //   });

  //   // 3 — Group logs by habit
  //   const habitSeriesMap = {};
  //   habitsMorning.forEach((habit) => {
  //     habitSeriesMap[habit._id] = {
  //       habitId: habit._id,
  //       habitName: habit.habitName,
  //       color: "#"+Math.floor(Math.random()*16777215).toString(16), // TEMP PALETTE
  //       points: []
  //     };
  //   });

  //   // 4 — Fill points
  //   sorted.forEach((d) => {
  //     habitSeriesMap[d.habitId].points.push({
  //       xValue: d.xValue,
  //       epochMinutes: d.epochMinutes,
  //     });
  //   });

  //   return {
  //     habitSeries: Object.values(habitSeriesMap),
  //     allDatePoints
  //   };
  // }, [chartData, habitsMorning]);

  // 5a — Unified dataset for Recharts multi-line plotting — 06  Dec 2025
  // const { unifiedData, unifiedSeries, allDateLabels } = React.useMemo(() => {
  //   if (!chartData || chartData.length === 0) {
  //     return { unifiedData: [], unifiedSeries: [], allDateLabels: [] };
  //   }

  //   // 5a.1 — Build ordered unique date labels
  //   const dateMap = new Map();
  //   chartData.forEach((d) => {
  //     if (!dateMap.has(d.dateKey)) {
  //       dateMap.set(d.dateKey, {
  //         dateKey: d.dateKey,
  //         xValue: d.xValue,
  //         xLabel: d.xLabel,
  //       });
  //     }
  //   });

  //   const allDateLabels = Array.from(dateMap.values()).sort(
  //     (a, b) => a.xValue - b.xValue
  //   );

  //   // 5a.2 — Initialize one row per day
  //   const unifiedData = allDateLabels.map((d) => ({
  //     xValue: d.xValue,
  //     xLabel: d.xLabel,
  //   }));

  //   // 5a.3 — Add habitName: null to each row
  //   if (habitsMorning && habitsMorning.length > 0) {
  //     unifiedData.forEach((row) => {
  //       habitsMorning.forEach((h) => {
  //         row[h.habitName] = null;
  //         // row[h.habitName] = undefined;
  //       });
  //     });
  //   }

  //   // 5a.4 — Fill the rows with epochMinutes from chartData

  //   const rowMap = {};
  //     unifiedData.forEach(row => {
  //       rowMap[row.xValue] = row;
  //   });

  //   chartData.forEach((point) => {
  //     const row = rowMap[point.xValue];
  //     if (row) {
  //       const key = point.habitName;
  //       row[key] = point.epochMinutes;
  //     }
  //   });


  //   // chartData.forEach((point) => {

  //   //   // const row = unifiedData[point.xValue];
  //   //   const row = rowMap[point.xValue];
  //   //   if (!row) return;
  //   //   const key = point.habitName; // Option A: habitName as dataKey
  //   //   if (row) {
  //   //     row[key] = point.epochMinutes;
  //   //   }
  //   //   // row[key] = point.epochMinutes;
  //   // });

  //   // 5a.5 — Build series (habitName + color)
  //   const colorPalette = ["#EA580C", "#2563EB", "#16A34A", "#DB2777", "#7C3AED"];

  //   const unifiedSeries = habitsMorning.map((habit, index) => {
  //     const color = colorPalette[index % colorPalette.length];
  //     return {
  //       habitId: habit._id,
  //       habitName: habit.habitName,
  //       color,
  //       dataKey: habit.habitName,
  //     };
  //   });


  //   // console.log('🔍 DEBUG unifiedData:', unifiedData);
  //   // console.log('🔍 DEBUG unifiedSeries:', unifiedSeries);
  //   // console.log('🔍 DEBUG chartData:', chartData);
  //   // console.log('🔍 DEBUG habitsMorning:', habitsMorning);

  //   return { unifiedData, unifiedSeries, allDateLabels };
  // }, [chartData, habitsMorning]);

  // 6 - Recharts requires flat hex colors - 06 Dec 2025
  const plexusColorHexMap = {
    Physical: "#EA580C",     // orange
    Mental: "#2563EB",       // blue
    Emotional: "#16A34A",    // green
    Intellectual: "#DB2777", // pink
    Spiritual: "#7C3AED",    // purple
  };

  // 7 - TickInterval
  const tickInterval = (() => {
    if (activeTimeBucket === "today") return 0;
    if (activeTimeBucket === "week") return 0;
    if (activeTimeBucket === "month") return 3;
    if (activeTimeBucket === "quarter") return 7;
    if (activeTimeBucket === "year") return 30;
  })();



  // 8 - Create an object for setting inner HTML
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
  }


  return (
    <div className="p-4 w-full max-w-6xl mx-auto font-poppins">

      <div className='flex justify-between items-center'>
          <h3 className="text-lg font-bold text-gray-800">Morning Energizers</h3>
            
          <button
            onClick={onClose}
            className="text-sm text-blue-600 underline"
          >
            Close
          </button>
      </div>

      {/* Time Filter Tabs - 01 Jul 2025*/}
      <div className="flex space-x-2 my-4">
        {[
          { label: 'Today', value: 'today' },
          { label: 'This Week', value: 'week' },
          { label: 'This Month', value: 'month' },
          { label: 'This Qtr', value: 'quarter' },
          { label: 'This Year', value: 'year' },
           // 02 Jan 2026 
          { label: 'By Year', value: 'byYear' },
          { label: 'All', value: 'all' },
          
        ].map(({ label, value }) => (
          <button
            key={value}
            onClick={() => setActiveTimeBucket(value)}
            className={`px-3 py-1 rounded-full text-sm font-semibold border shadow ${
              activeTimeBucket === value
                ? 'bg-orange-600 text-white border-orange-700'
                : 'bg-gray-100 text-gray-700 border-gray-300'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* -------------------------------------------------- */}
      {/* 02 Jan 2026 - Time bucket description */}
      {/* -------------------------------------------------- */}
      {timeBucketDescription && (
        <div className="mx-1 mt-1 mb-3 px-3 py-2 bg-orange-100 border-l-4 border-orange-500 rounded">
          <p className="text-sm text-gray-700">
            {timeBucketDescription}
          </p>
        </div>
      )}

      {/* -------------------------------------------------- */}
      {/* 02 Jan 2026 - Year selector (By Year mode) */}
      {/* -------------------------------------------------- */}
      {activeTimeBucket === 'byYear' && (
        <div className="flex flex-wrap gap-2 mt-2 mb-4 px-1">
          {availableYears.map((year) => (
            <button
              key={year}
              onClick={() => setActiveYear(year)}
              className={`px-3 py-1 rounded-full text-sm font-semibold border shadow
                ${
                  activeYear === year
                    ? 'bg-orange-600 text-white border-orange-700'
                    : 'bg-gray-100 text-gray-700 border-gray-300'
                }`}
            >
              {year}
            </button>
          ))}
        </div>
      )}




      

      <div className="py-4">

        {/* 06 Dec 2025 - View Tabs: Log | Chart */}
        <div className="flex space-x-2 mt-2 p-2 bg-gray-50 rounded">
          <button
            onClick={() => setActiveViewTab('log')}
            className={`text-sm font-semibold px-3 py-1 rounded-t 
              ${activeViewTab === 'log'
                ? 'bg-orange-200 text-orange-800'
                : 'text-gray-500'
              }`}
          >
            Log View
          </button>

          <button
            onClick={() => setActiveViewTab('chart')}
            className={`text-sm font-semibold px-3 py-1 rounded-t 
              ${activeViewTab === 'chart'
                ? 'bg-orange-200 text-orange-800'
                : 'text-gray-500'
              }`}
          >
            Chart View
          </button>

        </div>


        {/* 06 Dec 2025 - Log View (existing behaviour) */}

        {activeViewTab === 'log' && (
          <>
          
          {habits?.length === 0 && (
            <p className="text-sm text-gray-500">No morning habits configured yet.</p>
          )}

          {habits?.length > 0  && activeTimeBucket === 'today' && (
              <div className="my-4 py-4 bg-white rounded animate-slide-in-left">
                {/* Stats Bar */}
                <div className="py-4 bg-orange-100 m-2 p-2 rounded">
                  {percentLogged === 100 ? (
                    <p className="text-xl text-gray-700 mx-2 px-2">
                      You’ve completed <span className="font-bold text-2xl text-orange-600">100%</span> of your morning energizer habits <span className="bg-white rounded-full px-2 font-bold text-orange-800">today</span> ! 🎉🎉
                    </p>
                  ) : (
                    <p className="text-xl text-gray-700 mx-2 px-2">
                      You’ve completed <span className="font-bold text-2xl text-orange-600">{percentLogged}%</span> of your morning energizer habits — keep going! 💪
                    </p>
                  )}
                </div>

                {habitsMorning?.length >0 && habitsMorning?.map((habit, habitIndex) => {
                  const IconComp = plexusIconMap[habit.habitPlexus] || EtHabitsSortIcon1SVGComp;
                  const isChecked = selectedHabitIds.includes(habit._id);

                  const plexus = habit?.habitPlexus || ""
                  const name = habit?.habitName || ""
                  const desc = habit?.habitDesc || ""
                  const pic = habit?.pic || ""
                  // const instructions = habit?.habitInstructions || []
                  const instructions = habit?.timeBasedInstructions?.[0]?.morning || []
                  const MyHabitIcon = createSvgComponentFromBase64(pic)

                  return (
                    <div 
                    key={habit._id} 
                    className="py-2 animate-slide-in-left"
                    style={{ animationDelay: `${habitIndex * 200}ms`, animationFillMode: "forwards" }}
                    
                    >
                    <div  className="grid grid-cols-6 justify-between items-start space-x-2 m-2 p-2 border-t py-6">
                      {/* Plexus */}
                      <div className="col-span-1 flex justify-start items-center">
                          <input
                            type="checkbox"
                            // checked={isChecked}
                            checked={!!userHabitLogTodayMap[habit._id]}
                            onChange={() => {
                              setSelectedHabitIds(prev =>
                                prev.includes(habit._id)
                                  ? prev.filter(id => id !== habit._id)
                                  : [...prev, habit._id]
                              );
                            }}
                            className={`
                              mx-1 px-1 mr-2 pr-2 cursor-default appearance-none
                              w-5 h-5 rounded border-2
                              ${userHabitLogTodayMap[habit._id]
                                ? `bg-lime-500 border-lime-500 scale-150
                                  before:content-['✔'] before:absolute before:text-white 
                                  before:text-xs before:top-[1px] before:left-[3px] before:font-bold`
                                : `bg-white border-gray-400 scale-110`
                              }
                            `}
                          />
                          <div className='flex justify-center items-center w-10 h-10 rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-md'>
                              <IconComp className="h-8 w-8 text-white" />
                          </div>
                        
                        <div>
                          <p className="text-xs mx-1 px-1 text-gray-600">Energy Plexus:</p>
                          <p className={`text-md mx-1 px-2 font-bold rounded-full text-center ${plexusColorMap[habit.habitPlexus] || "bg-gray-100 text-gray-800"}`}>
                            {plexus}
                          </p>
                        </div>
                        
                      </div>
                      
                      {/* Habit */}
                      <div className="col-span-1 flex justify-start items-center">
                        <div
                            className={`h-8 w-8 rounded-full flex justify-center items-center cursor-pointer bg-white hover:bg-black}`}
                          >
                            {/* <MyIcon className="h-5 w-5" /> */}
                            <MyHabitIcon
                              className={`h-7 w-7 text-orange-600`}
                            />
                          </div>
                          <div>
                            <p className="text-[10px] mx-1 px-1 text-gray-600">Habit:</p>
                            <p className={`text-xs mx-1 px-2 font-bold rounded-full text-center bg-yellow-300`}>
                              {name}
                            </p>
                        </div>
                      </div>
                      
                      {/* Instructions */}
                      <div className="col-span-2 flex flex-col justify-start items-start">
                        <p className="mx-1 px-1 font-bold text-md border-b-2 border-orange-600">Action Guidance:</p>
                        {instructions?.length === 0 && (
                          <p className="text-xs leading-5 mx-1 px-1" dangerouslySetInnerHTML={createMarkup(desc)} ></p>
                        )}
                        {instructions?.length >0 && instructions?.map((ins, insIndex) => {

                          const guidance = ins?.instruction || ""

                          return(
                            <div key={ins+insIndex} className="bg-orange-50 rounded my-1 w-full">
                              <p className="text-xs mx-1 px-1 my-[1px] py-[1px]">{guidance}</p>
                            </div>
                          )
                        })}

                      </div>

                      {/* Performance  29 Jun 2025*/}
                      {/* Performance  02 Jul 2025*/}
                      <div className="col-span-2">
                        <EtHabitPerformanceDetail
                          habit={habit}
                          userHabitLogTodayMap={userHabitLogTodayMap}
                          performedToggle={performedToggle}
                          timePicker={timePicker}
                          experienceNotes={experienceNotes}
                          defaultTime={defaultTime}
                          setPerformedToggle={setPerformedToggle}
                          setTimePicker={setTimePicker}
                          setExperienceNotes={setExperienceNotes}
                          handleLogIt={handleLogIt}
                          handleUpdateHabitLog={handleUpdateHabitLog} // 01 Apr 2026
                        />
                      </div>
                      
                    </div>
                    </div>
                  );
                })}
              </div>
          )}

          {habits?.length > 0 && activeTimeBucket !== 'today' && (
            <div className="my-4 py-4 bg-white rounded animate-slide-in-left">
              {/* Stats Bar */}
                <div className="py-4 bg-orange-100 m-2 p-2 rounded">
                  {percentLoggedNotToday === 100 && (

                    <p className="text-xl text-gray-700 mx-2 px-2">
                      {activeTimeBucket === 'byYear' ? (
                        <>
                          You completed{" "}
                          <span className="font-bold text-2xl text-orange-600">
                            {percentLoggedNotToday}%
                          </span>{" "}
                          of your morning energizer habits in{" "}
                          <span className="font-bold text-orange-800">
                            {activeYear}
                          </span>.
                        </>
                      ) : (
                        <>
                          You’ve completed{" "}
                          <span className="font-bold text-2xl text-orange-600">
                            {percentLoggedNotToday}%
                          </span>{" "}
                          of your morning energizer habits{" "}
                          <span className="bg-white rounded-full px-2 font-bold">
                            this <span className="text-orange-800">{activeTimeBucket}</span>
                          </span>{" "}
                          — keep going! 💪
                        </>
                      )}
                    </p>

                    // <p className="text-xl text-gray-700 mx-2 px-2">
                    //   You’ve completed <span className="font-bold text-2xl text-orange-600">100%</span> of your morning energizer habits <span className="bg-white rounded-full px-2 font-bold">this <span className="text-orange-800">{activeTimeBucket}</span></span> ! 🎉🎉
                    // </p>
                  )} 
                  
                  {percentLoggedNotToday !== 100 &&(

                    <p className="text-xl text-gray-700 mx-2 px-2">
                      {activeTimeBucket === 'byYear' ? (
                        <>
                          You completed{" "}
                          <span className="font-bold text-2xl text-orange-600">
                            {percentLoggedNotToday}%
                          </span>{" "}
                          of your morning energizer habits in{" "}
                          <span className="font-bold text-orange-800">
                            {activeYear}
                          </span>.
                        </>
                      ) : (
                        <>
                          You’ve completed{" "}
                          <span className="font-bold text-2xl text-orange-600">
                            {percentLoggedNotToday}%
                          </span>{" "}
                          of your morning energizer habits{" "}
                          <span className="bg-white rounded-full px-2 font-bold">
                            this <span className="text-orange-800">{activeTimeBucket}</span>
                          </span>{" "}
                          — keep going! 💪
                        </>
                      )}
                    </p>

                    // <p className="text-xl text-gray-700 mx-2 px-2">
                    //   You’ve completed <span className="font-bold text-2xl text-orange-600">{percentLoggedNotToday}%</span> of your morning energizer habits <span className="bg-white rounded-full px-2 font-bold">this <span className="text-orange-800">{activeTimeBucket} </span> </span> — keep going! 💪
                    // </p>
                  )}
                </div>

                {/* <p className="text-sm text-gray-700 mb-2 font-semibold">
                Showing logs for: <span className="capitalize">{activeTimeBucket}</span>
              </p> */}

              
              {/* Group logs by day */}
              <div className="m-1 p-1 py-4 my-4">
                {(() => {
                  const logsByDay = {};

                  // 02 Jul 2025
                  displayedLogs.forEach(log => {
                    const dayKey = moment(log.performedAt).format('YYYY-MM-DD');
                    if (!logsByDay[dayKey]) logsByDay[dayKey] = {};
                    logsByDay[dayKey][log.habitId._id] = log;
                  });

                  // console.log('logsByDay', logsByDay)

                  return Object.entries(logsByDay)
                  ?.sort(([dateA], [dateB]) => moment(dateB).diff(moment(dateA)))
                  ?.map(([date, logs], idx) => {
                    const formattedDate = moment(date).format('ddd - DD MMM YYYY');
                    const isExpanded = expandedDays[date];

                    // console.log('logs in logsByDay', logs)


                    return (
                      <div 
                        key={date} 
                        className="animate-slide-in-left"
                        style={{ animationDelay: `${idx * 200}ms`, animationFillMode: "forwards" }}
                      >
                        {/* Header row */}

                        <div className="grid grid-cols-4 justify-start items-center border-t m-1 p-1 my-3 py-3 bg-gray-50">

                          <div className="col-span-1 flex justify-start items-center">
                            <div 
                              onClick={() =>
                                setExpandedDays(prev => ({ ...prev, [date]: !prev[date] }))
                              }
                              className="cursor-pointer"
                            >
                              {isExpanded ? (
                                <MinusIcon className="h-5 w-5 text-orange-600" />
                              ) : (
                                <PlusIcon className="h-5 w-5 text-orange-600" />
                              )}
                            </div>
                            <p className="font-bold text-gray-700 mx-1 px-1">{idx+1}.</p>
                            <p className="font-bold text-orange-700 mx-1 px-1">{formattedDate}</p>
                            
                          </div>

                          <div className="col-span-3 flex justify-between items-center">
                              {habitsMorning?.map((habit) => {
                                
                                const habitId = habit._id;
                                const log = logs?.[habitId] || null;
                                // console.log('log', log)
                                const isLogged = log?.performed || false;
                                const performedAt = log?.performedAt || ""
                                const name = habit?.habitName || "";
                                const pic = habit?.pic || "";
                                const MyHabitIcon = createSvgComponentFromBase64(pic);

                              return(
                                <div 
                                key={habitId}  
                                >
                                <div className="flex justify-start items-center pb-1">
                                  <div>
                                    <input
                                        type="checkbox"
                                        checked={isLogged}
                                        className={`
                                          mx-1 px-1 mr-2 pr-2 cursor-default appearance-none
                                          w-5 h-5 rounded border-2
                                          ${isLogged
                                            ? `bg-lime-500 border-lime-500 scale-110
                                              before:content-['✔'] before:absolute before:text-white 
                                              before:text-xs before:top-[1px] before:left-[3px] before:font-bold`
                                            : `bg-white border-gray-400 scale-100`
                                          }
                                        `}
                                      />
                                  </div>
                                  <div
                                    className={`h-8 w-8 rounded-full flex justify-center items-center cursor-pointer bg-white hover:bg-black}`}
                                  >
                                    <MyHabitIcon
                                      className={`h-7 w-7 text-orange-600`}
                                    />
                                  </div>
                                  <div>
                                      <p className="text-[10px] mx-1 px-1 text-gray-600">Habit:</p>
                                      <p className={`text-xs mx-1 px-2 font-bold rounded-full text-center bg-yellow-300`}>
                                        {name}
                                      </p>
                                  </div>
                                </div>
                                <div className="flex justify-start items-center border-t">
                                  <p className="text-xs mx-1 px-1 text-gray-400">Logged:</p>
                                  <div className="mx-1"><ClockIcon className="h-4 w-4 text-gray-400" /></div>
                                  {isLogged ? (
                                    <div> 
                                      <p className="text-gray-500 m-1 px-1 text-xs">
                                        {new Date(performedAt).toLocaleString('en-US', {
                                            // day: '2-digit',
                                            // month: 'short',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true,
                                        })}
                                      </p>
                                      {/* <p className="text-gray-500 m-1 px-1 rounded-full bg-orange-100 text-xs">
                                        {new Date(performedAt).toLocaleString('en-US', {
                                            day: '2-digit',
                                            month: 'short',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true,
                                        })}
                                      </p> */}
                                  </div>
                                  ) :(
                                    <p className="text-gray-500 m-1 px-1 text-xs">Not yet</p>
                                  )}
                                  
                                </div>
                                </div>
                              )
                            })}

                          </div>
                        </div>

                        {/* Expanded view - 02 Jul 2025 */}
                        {isExpanded && (
                          // <div className="ml-6 mt-2 border-l-4 border-orange-400 pl-4">
                          <div className=" m-1 p-1 bg-gray-50 rounded border border-orange-300">
                            {habitsMorning?.map(habit => {
                              const habitId = habit._id;
                              const log = logs?.[habitId] || null;

                              const IconComp = plexusIconMap[habit.habitPlexus] || EtHabitsSortIcon1SVGComp;
                              const plexus = habit?.habitPlexus || "";
                              const name = habit?.habitName || "";
                              const desc = habit?.habitDesc || "";
                              const pic = habit?.pic || "";
                              const instructions = habit?.timeBasedInstructions?.[0]?.morning || [];
                              const MyHabitIcon = createSvgComponentFromBase64(pic);

                              return (
                                <div key={habitId} className="grid grid-cols-12 justify-between items-start space-x-2 m-2 p-2">
                                  {/* Plexus */}
                                  <div className="col-span-2 flex justify-start items-center">
                                    <input
                                      type="checkbox"
                                      checked={!!log?.performed}
                                      className={`mx-1 px-1 mr-2 pr-2 cursor-default appearance-none w-5 h-5 rounded border-2 ${
                                        log?.performed
                                          ? `bg-lime-500 border-lime-500 scale-150
                                            before:content-['✔'] before:absolute before:text-white 
                                            before:text-xs before:top-[1px] before:left-[3px] before:font-bold`
                                          : `bg-white border-gray-400 scale-110`
                                      }`}
                                    />
                                    <div className='flex justify-center items-center w-10 h-10 rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-md'>
                                      <IconComp className="h-8 w-8 text-white" />
                                    </div>
                                    <div>
                                      <p className="text-xs mx-1 px-1 text-gray-600">Energy Plexus:</p>
                                      <p className={`text-md mx-1 px-2 font-bold rounded-full text-center ${plexusColorMap[habit.habitPlexus] || "bg-gray-100 text-gray-800"}`}>
                                        {plexus}
                                      </p>
                                    </div>
                                  </div>

                                  {/* Habit */}
                                  <div className="col-span-2 flex justify-start items-center">
                                    <div className="h-8 w-8 rounded-full flex justify-center items-center cursor-pointer bg-white hover:bg-black">
                                      <MyHabitIcon className="h-7 w-7 text-orange-600" />
                                    </div>
                                    <div>
                                      <p className="text-[10px] mx-1 px-1 text-gray-600">Habit:</p>
                                      <p className="text-xs mx-1 px-2 font-bold rounded-full text-center bg-yellow-300">{name}</p>
                                    </div>
                                  </div>

                                  {/* Instructions */}
                                  <div className="col-span-3 flex flex-col justify-start items-start">
                                    <p className="mx-1 px-1 font-bold text-md border-b-2 border-orange-600">Action Guidance:</p>
                                    {instructions?.length === 0 && (
                                      <p className="text-xs leading-5 mx-1 px-1" dangerouslySetInnerHTML={createMarkup(desc)} />
                                    )}
                                    {instructions?.length > 0 && instructions.map((ins, insIndex) => {
                                      const guidance = ins?.instruction || "";
                                      return (
                                        <div key={ins + insIndex} className="bg-orange-50 rounded my-1 w-full">
                                          <p className="text-xs mx-1 px-1 my-[1px] py-[1px]">{guidance}</p>
                                        </div>
                                      );
                                    })}
                                  </div>

                                  {/* Performance Detail (Read-only) */}
                                  <div className="col-span-5">
                                    {log && (
                                      <EtHabitPerformanceDetail
                                        habit={habit}
                                        userHabitLogTodayMap={{ [habitId]: log }}
                                        performedToggle={{}}
                                        timePicker={{}}
                                        experienceNotes={{}}
                                        defaultTime=""
                                        setPerformedToggle={() => {}}
                                        setTimePicker={() => {}}
                                        setExperienceNotes={() => {}}
                                        handleLogIt={() => {}}
                                      />
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}

                      </div>
                    );
                  });
                })()}
              </div>


            </div>
          )}
          
          </>
        )}

        {/* 06 Dec 2025 - Chart View placeholder (to be implemented next) */}
        {activeViewTab === 'chart' && (
          <div className="my-8 py-6 bg-white rounded shadow-sm border border-gray-200 animate-slide-in-left">

            {/* Chart Title */}

            {/* 25 Jul 2026 */}
            <p className="text-md font-semibold text-gray-700 mb-1 px-4">
              Habit Log Time by Date
            </p>

            <p className="text-xs text-gray-500 mb-3 px-4">
              The vertical axis shows the time of day each habit was logged.
              The horizontal axis shows the calendar date within the selected period.
            </p>



            {/* <p className="text-md font-semibold text-gray-700 mb-3 px-4">
              Habit Activity Chart — Time of Day vs Day
            </p> */}


            {/* 25 Jul 2026  */}
            <div className="px-4 mb-4">
              <div className="flex flex-col xl:flex-row xl:items-start gap-4">

                {/* Habit selection section */}
                <div className="flex flex-wrap gap-3 flex-1">

                  {habitsMorning.map(h => {
                            const MyHabitIcon = createSvgComponentFromBase64(h.pic);
                            const analytics = habitYearAnalytics?.[h._id];

                            const isVisible = visibleHabits.includes(h._id);

                            return (
                              <label
                                key={h._id}
                                className={`text-xs cursor-pointer border rounded-lg
                                ${
                                  isVisible
                                    ? 'flex flex-col items-stretch px-3 py-2 bg-orange-100 border-orange-300'
                                    : 'inline-flex items-center px-3 py-2 bg-white border-gray-200'
                                }
                              `}
                                // className={`flex flex-col items-stretch text-xs cursor-pointer px-3 py-2 border rounded-lg
                                //   ${
                                //     isVisible
                                //       ? 'bg-orange-100 border-orange-300'
                                //       : 'bg-white border-gray-200'
                                //   }
                                // `}
                              >
                                {/* Habit selection row */}
                                <div className="flex items-center gap-2 whitespace-nowrap">
                                  <input
                                    type="checkbox"
                                    checked={isVisible}
                                    onChange={() => {
                                      setVisibleHabits(prev =>
                                        prev.includes(h._id)
                                          ? prev.filter(id => id !== h._id)
                                          : [...prev, h._id]
                                      );
                                    }}
                                  />

                                  {MyHabitIcon && (
                                    <MyHabitIcon className="h-4 w-4 flex-shrink-0 text-orange-600" />
                                  )}

                                  <span className="font-semibold">
                                    {h.habitName}
                                  </span>
                                </div>

                                {/* 25 Jul 2026 - Year / By Year average and trend */}
                                {/* {showYearHabitAnalytics && (
                                  <div className="mt-2 pt-2 border-t border-orange-200">
                                    <p className="text-[10px] text-gray-500">
                                      Average time
                                    </p>

                                    <p className="text-xs font-bold text-gray-700">
                                      {formatHabitMinutes(analytics?.averageMinutes)}
                                    </p>

                                    <div className="flex items-center gap-2 mt-1">
                                      <div className="h-1.5 flex-1 bg-gray-200 rounded-full overflow-hidden">
                                        <div
                                          className={`h-full rounded-full ${
                                            analytics?.trendDirection === 'earlier'
                                              ? 'bg-green-500'
                                              : analytics?.trendDirection === 'later'
                                                ? 'bg-orange-500'
                                                : 'bg-gray-400'
                                          }`}
                                          style={{
                                            width:
                                              analytics?.trendDirection === 'none'
                                                ? '0%'
                                                : analytics?.trendDirection === 'steady'
                                                  ? '45%'
                                                  : '100%',
                                          }}
                                        />
                                      </div>

                                      <span
                                        className={`text-[10px] font-semibold whitespace-nowrap ${
                                          analytics?.trendDirection === 'earlier'
                                            ? 'text-green-700'
                                            : analytics?.trendDirection === 'later'
                                              ? 'text-orange-700'
                                              : 'text-gray-500'
                                        }`}
                                      >
                                        {formatHabitTrend(analytics?.trendMinutes)}
                                      </span>
                                    </div>
                                  </div>
                                )} */}

                                {showYearHabitAnalytics && hasHabitAnalyticsOverlay && isVisible && (
                                  <div className="mt-2 pt-2 border-t border-orange-200">
                                    {showHabitAverageBars && (
                                      <div>
                                        <p className="text-[10px] text-gray-500">
                                          Average time
                                        </p>

                                        <p className="text-xs font-bold text-gray-700">
                                          {formatHabitMinutes(analytics?.averageMinutes)}
                                        </p>
                                      </div>
                                    )}

                                    {showHabitTrendLines && (
                                      <div
                                        className={
                                          showHabitAverageBars
                                            ? 'mt-2'
                                            : ''
                                        }
                                      >
                                        <div className="flex items-center gap-2">
                                          <div className="h-1.5 flex-1 bg-gray-200 rounded-full overflow-hidden">
                                            <div
                                              className={`h-full rounded-full ${
                                                analytics?.trendDirection === 'earlier'
                                                  ? 'bg-green-500'
                                                  : analytics?.trendDirection === 'later'
                                                    ? 'bg-orange-500'
                                                    : 'bg-gray-400'
                                              }`}
                                              style={{
                                                width:
                                                  analytics?.trendDirection === 'none'
                                                    ? '0%'
                                                    : analytics?.trendDirection === 'steady'
                                                      ? '45%'
                                                      : '100%',
                                              }}
                                            />
                                          </div>
                                        </div>

                                        <p
                                          className={`mt-1 text-[10px] font-semibold ${
                                            analytics?.trendDirection === 'earlier'
                                              ? 'text-green-700'
                                              : analytics?.trendDirection === 'later'
                                                ? 'text-orange-700'
                                                : 'text-gray-500'
                                          }`}
                                        >
                                          {formatHabitTrend(analytics?.trendMinutes)}
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                )}



                              </label>
                            );
                  })}
                    </div>

                  {/* 25 Jul 2026 - Optional analytics overlays */}
                  {showYearHabitAnalytics && (
                    <div className="flex-shrink-0 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
                      <p className="text-[10px] font-semibold uppercase tracking-wide text-gray-500 mb-2">
                        Chart overlays
                      </p>

                      {/* <div className="flex xl:flex-col gap-3"> */}
                      <div className="flex items-center gap-4">
                        <label className="flex items-center gap-2 text-xs cursor-pointer whitespace-nowrap">
                          <input
                            type="checkbox"
                            checked={showHabitTrendLines}
                            onChange={(event) =>
                              setShowHabitTrendLines(event.target.checked)
                            }
                          />

                          <span className="font-semibold text-gray-700">
                            Show trend
                          </span>
                        </label>

                        <label className="flex items-center gap-2 text-xs cursor-pointer whitespace-nowrap">
                          <input
                            type="checkbox"
                            checked={showHabitAverageBars}
                            onChange={(event) =>
                              setShowHabitAverageBars(event.target.checked)
                            }
                          />

                          <span className="font-semibold text-gray-700">
                            Show avg bar
                          </span>
                        </label>
                      </div>

                      {hasHabitAnalyticsOverlay && (
                        <p className="mt-2 max-w-[180px] text-[10px] leading-4 text-gray-500">
                          Habit activity lines are faded while analytics overlays are shown.
                        </p>
                      )}
                    </div>
                  )}

                </div>
              </div>


            {/* 07 Dec 2025 - Habit Filter */}
            {/* <div className="flex gap-3 px-4 mb-3 flex-wrap">          
                           
              
               {habitsMorning.map(h => {
                const MyHabitIcon = createSvgComponentFromBase64(h.pic);

                return (
                  <label
                    key={h._id}
                    // className="flex items-center gap-2 text-xs cursor-pointer px-2 py-1 border rounded-full"
                    className={`flex items-center gap-2 text-xs cursor-pointer px-2 py-1 border rounded-full 
                      ${visibleHabits.includes(h._id) ? 'bg-orange-100 border-orange-300' : ''}
                    `}
                  >
                    <input
                      type="checkbox"
                      checked={visibleHabits.includes(h._id)}
                      onChange={() => {
                        setVisibleHabits(prev =>
                          prev.includes(h._id)
                            ? prev.filter(id => id !== h._id)
                            : [...prev, h._id]
                        );
                      }}
                    />

                    
                    {MyHabitIcon && (
                      <MyHabitIcon className="h-4 w-4 flex-shrink-0 text-orange-600" />
                    )}

                    <span>{h.habitName}</span>
                  </label>
                );
              })} 

            </div> */}


            {/* 06 Dec 2025 - Recharts Chart */}
            <div className="w-full h-[450px] text-xs">
              <ResponsiveContainer>
                <ComposedChart
                  // data={unifiedData}
                  data={allDatePoints}
                  margin={{ top: 20, right: 30, bottom: 20, left: 20 }}
                  // margin={{ top: 20, right: 30, bottom: 20, left: 10 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />

                  {/* <XAxis 
                    type="number"
                    ticks={allDateLabels.map(d => d.xValue)}
                    tickFormatter={(x) => {
                      const item = allDateLabels.find((d) => d.xValue === x);
                      return item?.xLabel || "";
                    }}
                  /> */}

                  <XAxis 
                    dataKey="xValue"
                    type="number"
                    // domain={[0, unifiedData.length - 1]}
                    domain={['dataMin', 'dataMax']}
                    // ticks={unifiedData.map(d => d.xValue)}
                    ticks={allDatePoints.map(d => d.xValue)}
                    tickFormatter={(x) => {
                      // const item = unifiedData.find((d) => d.xValue === x);
                      const item = allDatePoints.find((d) => d.xValue === x);
                      return item?.xLabel || "";
                    }}
                    // tick={{ angle: -15, textAnchor: "end", dy: 8 }}
                    // tick={{ angle: 0, textAnchor: "start", dy: 8 }}
                    
                  />

                  <YAxis 
                    type="number"
                    // domain={[0, 1440]}
                    // ticks={[0, 180, 360, 540, 720, 900, 1080, 1260, 1440]}
                    domain={[60, 720]}
                    ticks={[60, 180, 360, 540, 720]}
                    tickFormatter={(m) =>
                      moment().startOf("day").add(m, "minutes").format("h A")
                    }
                    label={{ 
                      value: 'Time', 
                      angle: -90, 
                      position: 'insideLeft',
                      // position: 'insideCenter',
                      offset: -3, 
                     }}
                  />

                  {/* <Tooltip /> */}
                  <Tooltip
                    content={({ active, payload, label }) => {
                      if (!active || !payload || payload.length === 0) return null;
                      
                      // const dateLabel = allDateLabels.find(d => d.xValue === label)?.xLabel || label;
                      const dateLabel = allDatePoints.find(d => d.xValue === label)?.xLabel || label;


                      
                      return (
                        <div className="bg-white p-3 border border-gray-300 rounded shadow-lg">
                          <p className="font-semibold text-gray-700 mb-2">{dateLabel}</p>
                          {payload.map((entry, index) => {

                             if (
                                entry.value === undefined ||
                                entry.value === null ||
                                entry.name?.endsWith(' trend')
                              ) {
                                return null;
                              }
                            
                            // if (entry.value === undefined || entry.value === null) return null;
                            
                            const timeFormatted = moment()
                              .startOf("day")
                              .add(entry.value, "minutes")
                              .format("h:mm A");
                            return (
                              <p key={index} className="text-sm" style={{ color: entry.color }}>
                                {entry.name}: {timeFormatted}
                              </p>
                            );
                          })}
                        </div>
                      );
                    }}
                  />
                  
                    <Legend wrapperStyle={{ paddingTop: 20 }}/>
                  

                  {/* NEW MULTI-SERIES LINES */}
                  {/* 25 Jul 2026 */}
                  {habitSeries
                  .filter(series => visibleHabits.includes(series.habitId))
                  .map((series) => {
                    const analytics =
                      habitYearAnalytics?.[series.habitId];

                    return (
                      <React.Fragment key={series.habitId}>
                        {/* Actual logged habit times */}
                        {/* <Line
                          type="monotone"
                          data={series.points}
                          dataKey="epochMinutes"
                          xAxisId={0}
                          yAxisId={0}
                          stroke={series.color}
                          strokeWidth={1.5}
                          dot={{ r: 1.5, fill: series.color }}
                          name={series.habitName}
                          connectNulls={true}
                        /> */}

                        <Line
                          type="monotone"
                          data={series.points}
                          dataKey="epochMinutes"
                          xAxisId={0}
                          yAxisId={0}
                          stroke={series.color}
                          strokeWidth={hasHabitAnalyticsOverlay ? 1 : 1.5}
                          strokeOpacity={hasHabitAnalyticsOverlay ? 0.1 : 1}
                          dot={
                            hasHabitAnalyticsOverlay
                              ? {
                                  r: 1,
                                  fill: series.color,
                                  fillOpacity: 0.12,
                                  strokeOpacity: 0.12,
                                }
                              : {
                                  r: 1.5,
                                  fill: series.color,
                                }
                          }
                          activeDot={
                            hasHabitAnalyticsOverlay
                              ? false
                              : {
                                  r: 3,
                                }
                          }
                          name={series.habitName}
                          connectNulls={true}
                          isAnimationActive={false}
                        />

                        {/* 25 Jul 2026 - Average time bar */}
                        {showYearHabitAnalytics &&
                         showHabitAverageBars &&
                          Number.isFinite(analytics?.averageMinutes) && (
                            <ReferenceLine
                              y={analytics.averageMinutes}
                              yAxisId={0}
                              stroke={series.color}
                              strokeWidth={2}
                              strokeDasharray="8 5"
                              ifOverflow="extendDomain"
                              label={{
                                value: `${series.habitName} :  Avg Time : ${formatHabitMinutes(
                                  analytics.averageMinutes
                                )}`,
                                position: 'center',
                                fill: series.color,
                                fontSize: 10,
                                fontWeight: 400,
                                dy: -12,
                              }}
                              // label={{
                              //   value: `${series.habitName} avg`,
                              //   position: 'insideRight',
                              //   fill: series.color,
                              //   fontSize: 10,
                              //   dy: -8, // 25 Jul 2026 - Push label above average line
                              // }}
                            />
                          )}

                        {/* 25 Jul 2026 - Linear trend bar */}
                        {showYearHabitAnalytics &&
                        showHabitTrendLines &&
                          analytics?.trendPoints?.length > 1 && (
                            <Line
                              data={analytics.trendPoints}
                              dataKey="epochMinutes"
                              xAxisId={0}
                              yAxisId={0}
                              type="linear"
                              stroke={series.color}
                              strokeWidth={2}
                              strokeDasharray="2 2"
                              // dot={false}
                              dot={(dotProps) =>
                                renderTrendEndpoint({
                                  ...dotProps,
                                  seriesColor: series.color,
                                  totalPoints: analytics.trendPoints.length,
                                })
                              }
                              activeDot={false}
                              connectNulls={true}
                              name={`${series.habitName} trend`}
                              legendType="none"
                              isAnimationActive={false}
                            />
                          )}
                      </React.Fragment>
                    );
                  })}

                  {/* {habitSeries
                    .filter(series => visibleHabits.includes(series.habitId))
                    .map((series) => (
                      <Line
                        key={series.habitId}
                        type="monotone"
                        data={series.points}        // <- IMPORTANT: per-habit dataset
                        dataKey="epochMinutes"
                        xAxisId={0}
                        yAxisId={0}
                        stroke={series.color}
                        strokeWidth={2}
                        dot={{ r: 4, fill: series.color }}
                        name={series.habitName}
                        connectNulls={true}
                      />
                  ))} */}

                  {/* {unifiedSeries.map((series) => (
                    <Line
                      key={series.habitId}
                      type="monotone"
                      dataKey={series.dataKey}
                      stroke={series.color}
                      strokeWidth={2}
                      dot={{ r: 4, fill: series.color }}
                      name={series.habitName}
                      connectNulls={true}
                      // connectNulls={false}
                    />
                  ))} */}

                </ComposedChart>

              </ResponsiveContainer>
            </div>


            

          </div>
        )}

      </div>

      
    </div>
  );
};

export default EtTrinityMorningHabits;